import pipe from "@insightfulscience/shared-utils/fn/pipe";
import Cookies from "./cookies";
import nextSignleton from "../utils/nextSignleton";
import { publicConfig } from "../config";

const { COOKIE_NAME } = publicConfig;

const tokenApi = cookies => ({
	/** @type {() => string} */
	get: () => cookies.read(COOKIE_NAME),
	/** @type {(token: string, expires: number) => void} */
	set: (token, expires) => {
		if (token == null) {
			cookies.remove(COOKIE_NAME);
			cookies.write(COOKIE_NAME, null);
			return;
		}
		cookies.write(COOKIE_NAME, token, expires && { expires });
	},
});

const Token = nextSignleton(
	globalConext => tokenApi(Cookies(globalConext)), // Token Factory
);

/** @type {<T extends {}>(token: string) => T | null} */
const parseToken = token => {
	const b64Payload = token.split(".")[1];
	if (!b64Payload) return null;
	const payloadJson = Buffer.from(b64Payload, "base64").toString("utf-8");
	try {
		return JSON.parse(payloadJson);
	} catch (err) {
		return null;
	}
};

/** @type {(token: { exp: number }) => boolean} */
export const isNotExpired = token => token && token.exp * 1000 > Date.now();

/** @type {(token: string) => boolean} */
export const isTokenValid = token => Boolean(token) && (pipe(token, parseToken));

export default Token;

global.Token = Token;
